// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"2d6dcb61","845":"e21d2516"}[chunkId] + ".chunk.js";
};